import { Image as ImageIcon } from "lucide-react";

/**
 * Elegant placeholder used in place of photographs.
 * The user opted out of stock photos — this is intentional, branded scaffolding
 * so real photographs can be dropped in later.
 */
export default function Placeholder({
  label,
  caption,
  icon: Icon = ImageIcon,
  className = "",
  ratio = "aspect-[4/5]",
  tone = "light",
  index,
}) {
  const isDark = tone === "dark";
  return (
    <div
      data-testid={`placeholder-${(label || "image").toLowerCase().replace(/\s+/g, "-")}`}
      className={`relative overflow-hidden rounded-2xl ${ratio} ${className} ${
        isDark
          ? "bg-[#1E2823] border border-white/10"
          : "bg-[#EFEAE4] border border-[#6A7B61]/20"
      } grain group`}
    >
      {/* corner ornaments */}
      <span className={`absolute top-4 left-4 h-3 w-3 border-t border-l ${isDark ? "border-[#F7F5F0]/40" : "border-[#2C392F]/40"}`} />
      <span className={`absolute top-4 right-4 h-3 w-3 border-t border-r ${isDark ? "border-[#F7F5F0]/40" : "border-[#2C392F]/40"}`} />
      <span className={`absolute bottom-4 left-4 h-3 w-3 border-b border-l ${isDark ? "border-[#F7F5F0]/40" : "border-[#2C392F]/40"}`} />
      <span className={`absolute bottom-4 right-4 h-3 w-3 border-b border-r ${isDark ? "border-[#F7F5F0]/40" : "border-[#2C392F]/40"}`} />

      <div className="absolute inset-0 flex flex-col items-center justify-center p-8 text-center transition-transform duration-700 group-hover:scale-[1.015]">
        {typeof index === "number" && (
          <div className={`serif text-xs tracking-[0.4em] mb-4 ${isDark ? "text-[#F7F5F0]/50" : "text-[#985F47]/70"}`}>
            № {String(index).padStart(2, "0")}
          </div>
        )}
        <Icon
          className={`mb-4 ${isDark ? "text-[#F7F5F0]/40" : "text-[#6A7B61]"}`}
          size={28}
          strokeWidth={1.4}
        />
        <div className={`serif text-2xl md:text-3xl leading-tight ${isDark ? "text-[#F7F5F0]" : "text-[#2C392F]"}`}>
          {label}
        </div>
        {caption && (
          <div className={`mt-2 text-xs uppercase tracking-[0.25em] ${isDark ? "text-[#F7F5F0]/50" : "text-[#985F47]/80"}`}>
            {caption}
          </div>
        )}
        <div className={`mt-6 text-[10px] uppercase tracking-[0.3em] ${isDark ? "text-[#F7F5F0]/30" : "text-[#1A1C1A]/30"}`}>
          ChiMano House · Photograph placeholder
        </div>
      </div>
    </div>
  );
}
